import React from "react";
import { Timeline, Events, UrlButton, ImageEvent } from "@merc/react-timeline";

// projects
import A_Food from "../../assets/img/projects/Food.png";
import A_learning from "../../assets/img/projects/Online Learning.png";
import A_Ciclo from "../../assets/img/projects/Ciclo.png";



import "./projects-timeline.styles.css";
import { Link } from "react-router-dom";

const TimeLine = () => {
  return (
    <div id="projects" className="project_main">
      <h1 className="pt-3 text-center font-details-b pb-3">PROJECTS</h1>
      <Timeline className="line">
        <Events className="line">
          {/* Amazon */}
          <ImageEvent
            date="Hungry"
            className="text-center"
            text="Hungry Food Delivery App"
            src={A_Food}
            alt=""
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div></div>
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <Link to="/hungry">
                  <UrlButton>Case Study</UrlButton>
                </Link>
                <UrlButton
                  href="https://www.figma.com/proto/QtLoz8FGXa8Yj1IkAxvmzw/Food-delivery-app-high?node-id=280%3A1903&scaling=scale-down&page-id=280%3A1467&starting-point-node-id=280%3A1903"
                  target="_blank"
                >
                  Prototype
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* Project: covid tracker */}
          <ImageEvent
            date="Alpha"
            className="text-center"
            text="Alpha E-learning App"
            src={A_learning}
            alt=""
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <Link to="/alpha">
                  <UrlButton>Case Study</UrlButton>
                </Link>
                <UrlButton
                  href="https://www.figma.com/proto/ToSXZhPM8V0O0XT0PKmBjC/Online-Learning?node-id=16%3A1597&scaling=scale-down&page-id=0%3A1&starting-point-node-id=16%3A1597"
                  target="_blank"
                >
                    Prototype
                </UrlButton>
              </div>
            </div>
          </ImageEvent>

          {/* spotify clone */}
          <ImageEvent
            date="Ciclo"
            className="text-center"
            text="Ciclo E-Bike Website"
            src={A_Ciclo}
            alt=""
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div className="d-flex justify-content-between flex-nowrap text-center">
                <Link to="/ciclo">
                  <UrlButton>Case Study</UrlButton>
                </Link>
                <UrlButton
                  href="https://xd.adobe.com/view/87d637a1-3bf2-43bf-b02b-570fea5af24b-d285/?fullscreen&hints=off"
                  target="_blank"
                >
                  Prototype
                </UrlButton>
              </div>
            </div>
          </ImageEvent>
        </Events>
      </Timeline>
    </div>
  );
};

export default TimeLine;
